import { Injectable } from '@angular/core';
import { errors } from './errors';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {
  constructor() {}

  public getError(error: string): string {
    if (<string>errors.get(error)) {
      return <string>errors.get(error);
    } else {
      console.error(error);
      return <string>errors.get('DEFAULT');
    }
  }
}
